import {NgModule} from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ApplicationComponent} from './Application/application.component';
import {AuthenticationViewComponent} from './Authentication/View/authentication-view.component';
import {AuthGuardService} from './Authentication/auth-guard.service';
import {ImageWizardComponent} from './Editor/Image/ImageWizard/image-wizard.component';



const routes: Routes = [
    // {path: '', redirectTo: '/burns', pathMatch: 'full', canActivateChild: [AuthGuardService]},
    {path: '', component: ApplicationComponent, canActivate: [AuthGuardService]},
    {path: 'auth', component: AuthenticationViewComponent},
    {path: 'burns/:id', component: ApplicationComponent, canActivate: [AuthGuardService]},
    {path: 'burns', component: ApplicationComponent, canActivate: [AuthGuardService]},
    {path: 'imageWizard', component: ImageWizardComponent, canActivate: [AuthGuardService]}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {enableTracing: false})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

export const routingComponents = [AuthenticationViewComponent, ApplicationComponent];
